import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { useSelector } from "react-redux";
import LoginPage from "../features/Auth/pages/LoginPage";
import ChatPage from "../features/Chat/pages/ChatPage";
import ManageShopPage from "../features/Shop/pages/ManageShopPage";
import ChatbotSettingsPage from "../features/Chatbot/pages/ChatbotSettingsPage";
import ChatbotKeywordPage from "../features/Chatbot/pages/ChatbotKeywordPage";
import ReportsLayout from "../features/Reports/pages/ReportsLayout";
import ReportsHubPage from "../features/Reports/pages/ReportsHubPage";
import ActivityReportPage from "../features/Reports/pages/ActivityReportPage";
import StaffTab from "../features/Reports/pages/StaffTab";
import ConversationsTab from "../features/Reports/pages/ConversationsTab";
import HeatmapTab from "../features/Reports/pages/HeatmapTab";
import PipelineReportPage from "../features/Reports/pages/PipelineReportPage";
import TagsReportPage from "../features/Reports/pages/TagsReportPage";
import ContactsLayout from "../features/Contacts/pages/ContactsPage/ContactsLayout";
import FriendsTab from "../features/Contacts/pages/FriendsTab";
import GroupsTab from "../features/Contacts/pages/GroupsTab";
import FriendRequestsTab from "../features/Contacts/pages/FriendRequestsTab";
import FriendHistoryTab from "../features/Contacts/pages/FriendHistoryTab";
import GroupInvitationsTab from "../features/Contacts/pages/GroupInvitationsTab";
import Layout from "../components/Layout";
import RequireChatbotEvent from "../components/RequireChatbotEvent";
import { useState } from "react";
import LoadingScreen from "../components/LoadingScreen";

const AppRoutes = () => {
  const auth = useSelector((state) => state.auth);

  const [isLoadingScreen, setIsLoadingScreen] = useState(false);

  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route
            path="/*"
            element={
              auth.isAuthenticated ? (
                <Navigate to="/" replace />
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />
          <Route
            path="/login"
            element={
              auth.isAuthenticated ? <Navigate to="/" replace /> : <LoginPage />
            }
          />
          {auth.isAuthenticated ? (
            <Route path="/" element={<Layout />}>
              <Route index element={<Navigate to="/shop" replace />} />
              <Route
                path="chat/:shopId"
                element={<ChatPage setIsLoadingScreen={setIsLoadingScreen} />}
              />
              <Route
                path="chat/group/:groupId"
                element={<ChatPage setIsLoadingScreen={setIsLoadingScreen} />}
              />
              <Route
                path="chat/multi/:shopIds"
                element={<ChatPage setIsLoadingScreen={setIsLoadingScreen} />}
              />
              <Route
                path="shop"
                element={
                  <ManageShopPage setIsLoadingScreen={setIsLoadingScreen} />
                }
              />
              <Route
                path="chatbot/settings"
                element={
                  <RequireChatbotEvent>
                    <ChatbotSettingsPage />
                  </RequireChatbotEvent>
                }
              />
              <Route path="chatbot/qa" element={<ChatbotKeywordPage />} />
              <Route path="reports" element={<ReportsLayout />}>
                <Route index element={<Navigate to="/reports/overview" replace />} />
                <Route path="overview" element={<ReportsHubPage />} />
                <Route path="activity" element={<ActivityReportPage />} />
                <Route path="staff" element={<StaffTab />} />
                <Route path="conversations" element={<ConversationsTab />} />
                <Route path="heatmap" element={<HeatmapTab />} />
                <Route path="pipeline" element={<PipelineReportPage />} />
                <Route path="tags" element={<TagsReportPage />} />
              </Route>
              <Route path="contacts" element={<ContactsLayout />}>
                <Route
                  index
                  element={<Navigate to="/contacts/friends" replace />}
                />
                <Route path="friends" element={<FriendsTab />} />
                <Route path="groups" element={<GroupsTab />} />
                <Route
                  path="friend-requests"
                  element={<FriendRequestsTab />}
                />
                {/* Redirect các route cũ sang trang gộp */}
                <Route
                  path="sent-requests"
                  element={<Navigate to="/contacts/friend-requests" replace />}
                />
                <Route
                  path="received-requests"
                  element={<Navigate to="/contacts/friend-requests" replace />}
                />
                <Route path="friend-history" element={<FriendHistoryTab />} />
                <Route
                  path="group-invitations"
                  element={<GroupInvitationsTab />}
                />
              </Route>
            </Route>
          ) : (
            <Route path="/" element={<Navigate to="/login" replace />} />
          )}
        </Routes>
      </BrowserRouter>
      {isLoadingScreen && <LoadingScreen />}
    </>
  );
};

export default AppRoutes;
